import { useEffect } from "react";
import {
  DEFAULT_VIEWPORT_LIGHTS,
  getViewportLightingOptions,
  subscribeViewportLightingOptions,
} from "../../utils/defaultViewportLights";

function applyViewportLighting(scene) {
  if (!scene) return;
  const options = getViewportLightingOptions();
  const ambientLight =
    scene.getObjectByName(DEFAULT_VIEWPORT_LIGHTS.ambient.name) ||
    scene.children.find((child) => child?.type === "AmbientLight");
  if (ambientLight) {
    ambientLight.name = DEFAULT_VIEWPORT_LIGHTS.ambient.name;
    ambientLight.intensity = options.ambient.intensity;
    ambientLight.color?.set?.(options.ambient.color);
  }

  const hemisphereLight =
    scene.getObjectByName(DEFAULT_VIEWPORT_LIGHTS.hemisphere.name) ||
    scene.children.find((child) => child?.type === "HemisphereLight");
  if (hemisphereLight) {
    hemisphereLight.name = DEFAULT_VIEWPORT_LIGHTS.hemisphere.name;
    hemisphereLight.intensity = options.hemisphere.intensity;
    hemisphereLight.color?.set?.(options.hemisphere.skyColor);
    hemisphereLight.groundColor?.set?.(options.hemisphere.groundColor);
  }
}

export function useViewportLightingSync({ sceneRef }) {
  useEffect(() => {
    applyViewportLighting(sceneRef.current);
    return subscribeViewportLightingOptions(() => {
      applyViewportLighting(sceneRef.current);
    });
  }, [sceneRef]);
}
